import React from 'react';
import { Card } from './ui/Card';
import { Eye, Filter } from 'lucide-react';
import { AnimatedNumber } from './AnimatedNumber';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface WorkersData {
  present: number;
  safetyOrientation: number;
  oshaAct: number;
  mandatoryDocuments: number;
}
interface WorkersCardProps {
  data: WorkersData;
  isFiltered?: boolean;
}
export function WorkersCard({
  data,
  isFiltered
}: WorkersCardProps) {
  return <Card className="h-full flex flex-col" data-id="element-4000">
      <div className="flex justify-between items-start mb-4" data-id="element-4001">
        <div className="flex items-center gap-2" data-id="element-4002">
          <h3 className="font-bold text-gray-900 text-sm" data-id="element-4003">Workers</h3>
          {isFiltered && <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex items-center gap-1 bg-amber-100 text-amber-700 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full" data-id="element-4004">
              <Filter size={10} data-id="element-4005" />
              Filtered
            </motion.div>}
        </div>
        <Link to="/workers" className="flex items-center gap-1.5 text-xs font-medium text-gray-600 border border-gray-200 rounded px-2.5 py-1 hover:bg-gray-50 transition-colors" data-id="element-4006">
          <Eye size={14} data-id="element-4007" />
          View all
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center mb-6" data-id="element-4008">
        <div className="relative w-40 h-40" data-id="element-4009">
          {/* Donut Chart Placeholder */}
          <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-4010">
            <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" strokeWidth="12" data-id="element-4011" />
            <circle cx="50" cy="50" r="40" fill="none" stroke="#ef4444" strokeWidth="12" strokeDasharray="251.2" strokeDashoffset="50" data-id="element-4012" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-4013">
            <AnimatedNumber value={data.present} className="text-4xl font-bold text-gray-900" data-id="element-4014" />
            <span className="text-xs text-gray-500" data-id="element-4015">Present</span>
          </div>
        </div>
      </div>

      <div className="space-y-2 pt-4 border-t border-gray-200" data-id="element-4016">
        <div className="flex items-center justify-between text-sm" data-id="element-4017">
          <span className="text-gray-700" data-id="element-4018">JH - Safety orientation</span>
          <AnimatedNumber value={data.safetyOrientation} className="font-semibold" data-id="element-4019" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-4020">
          <span className="text-gray-700" data-id="element-4021">W - OSHA / ACT</span>
          <AnimatedNumber value={data.oshaAct} className="font-semibold" data-id="element-4022" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-4023">
          <span className="text-gray-700" data-id="element-4024">217 - Mandatory documents</span>
          <AnimatedNumber value={data.mandatoryDocuments} className="font-semibold" data-id="element-4025" />
        </div>
      </div>
    </Card>;
}